import React from 'react';
import { colors, Div, weight } from 'globalStyle';
import { TextLight } from 'components/Texts';
import { Hollow } from 'components/Buttons';
import { ColorBackgroundTitle } from 'components/Modals/ColorBackgroundTitle';
import { capitalizeFirstLetterString } from 'util/capitalizeFirstLetter';
import { formatNumber } from 'util/formatNumber';
import { routes } from 'routes';
import styled from 'styled-components';
import { projectTypes, issuanceTypes, typesProjectType } from 'types/projectType';

export const SuccessfulInvestmentModal = ({
  currentAmountAfterInvestment,
  companyName,
  onClick,
  projectName,
  maxAmount,
  currencyIso,
  amountInvested,
  projectType,
  issuanceType,
  nodeValue,
  nodePerPackage,
}) => {
  const Title = () => (
    <Div padding="15px 5px" style={{ minHeight: '90px' }}>
      <TextLight color={colors.WHITE} size={14} align="center">
        Inversión
      </TextLight>
      <TextLight
        color={colors.WHITE}
        weight={weight.BOLD}
        align="center"
        size={18}
      >
        {capitalizeFirstLetterString(projectName)}
      </TextLight>
      <TextLight
        color={colors.WHITE}
        align="center"
        size={14}
        weight={weight.BOLD}
      >
        {`Proyecto de ${capitalizeFirstLetterString(companyName)}`}
      </TextLight>
    </Div>
  );

  const PopupContent = () => {
    if (projectType === projectTypes.STOCKS) {
      return (
        <TextLight size={18}>
          Has invertido
          <span style={{ fontWeight: weight.BOLD, margin: '0 3px' }}>
            {`${
              issuanceType === issuanceTypes.INDIVIDUAL
                ? `en ${amountInvested / nodeValue} ${
                  amountInvested / nodeValue > 1 ? typesProjectType[projectType] : 'Acción'
                }`
                : `en ${amountInvested / (nodeValue * nodePerPackage)} ${
                  amountInvested / (nodeValue * nodePerPackage) > 1
                    ? 'paquetes'
                    : 'paquete'
                }`
            } `}
          </span>
          en el proyecto
          <span style={{ fontWeight: weight.BOLD, margin: '0 3px' }}>
            {capitalizeFirstLetterString(projectName)}
          </span>
        </TextLight>
      );
    }
    if (projectType === projectTypes.TOKENS) {
      return (
        <TextLight size={18}>
          Has invertido
          <span style={{ fontWeight: weight.BOLD, margin: '0 3px' }}>
            {`${
              issuanceType === issuanceTypes.INDIVIDUAL
                ? `en ${amountInvested / nodeValue} ${
                  amountInvested / nodeValue > 1 ? typesProjectType[projectType] : 'Token'
                }`
                : `en ${amountInvested / (nodeValue * nodePerPackage)} ${
                  amountInvested / (nodeValue * nodePerPackage) > 1
                    ? 'paquetes'
                    : 'paquete'
                }`
            } `}
          </span>
          en el proyecto
          <span style={{ fontWeight: weight.BOLD, margin: '0 3px' }}>
            {capitalizeFirstLetterString(projectName)}
          </span>
        </TextLight>
      );
    }
    return (
      <TextLight size={18}>
        La inversión de
        <span style={{ fontWeight: weight.BOLD, margin: '0 3px' }}>
          {formatNumber(amountInvested, null, currencyIso)}
        </span>
        en el proyecto
        <span style={{ fontWeight: weight.BOLD, margin: '0 3px' }}>
          {capitalizeFirstLetterString(projectName)}
        </span>
        se ha realizado con éxito.
      </TextLight>
    );
  };
  return (
    <ColorBackgroundTitle
      title={<Title />}
      isOpen
      handleBack={() => {
        onClick();
      }}
      handleClose={() => {
        onClick();
      }}
    >
      <Div p="30px 50px">
        <PopupContent />
        <Line margin="30px 0 20px" />
        <VerticalLine>
          <Div>
            <TextLight
              color={colors.primary}
              weight={weight.BOLD}
              mb={5}
              width="auto"
              size={14}
            >
              Total recaudado
            </TextLight>
            <TextLight weight={weight.BOLD} width="auto" size={20}>
              {formatNumber(currentAmountAfterInvestment, null, currencyIso)}
            </TextLight>
          </Div>
          <Div>
            <TextLight
              color={colors.primary}
              weight={weight.BOLD}
              mb={5}
              width="auto"
              size={14}
            >
              Meta del proyecto
            </TextLight>
            <TextLight weight={weight.BOLD} width="auto" size={20}>
              {formatNumber(maxAmount, null, currencyIso)}
            </TextLight>
          </Div>
        </VerticalLine>
        <Div isFlex width="100%" justify="space-between" mt={50}>
          <Hollow
            onColorType="white"
            color={colors.primary}
            href={routes.home}
            padding="12px 0"
            size="14px"
            style={{ borderRadius: '30px', width: '220px', height: '45px' }}
          >
            Inicio
          </Hollow>
          <Hollow
            onColorType="primary"
            href={routes.profile.invert}
            padding="12px 0"
            size="14px"
            style={{ borderRadius: '30px', width: '220px', height: '45px' }}
          >
            Mis inversiones
          </Hollow>
        </Div>
      </Div>
    </ColorBackgroundTitle>
  );
};

const Line = styled.div`
  width: 100%;
  margin: ${({ margin }) => margin && margin};
  height: 1px;
  border-bottom: 2px solid ${colors.input.inactive};
`;

const VerticalLine = styled.div`
  display: flex;
  justify-content: space-around;
  height: 70px;
  position: relative;
  width: 100%;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 2px;
    height: 100%;
    background-color: ${colors.input.inactive};
  }
`;
